module.exports = __webpack_public_path__ + "assets/img/info-btn-cdd8e628.png";